import { createSlice } from '@reduxjs/toolkit';

export const builderLinkSlice = createSlice({
  name: 'builderLink',
  initialState: false,
  reducers: {},
});

export const { reducer: builderLinkReducer } = builderLinkSlice;
